<template>
  <div style="padding-bottom: 5px">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>Home</el-breadcrumb-item>
      <el-breadcrumb-item>Administrator</el-breadcrumb-item>
      <el-breadcrumb-item>Template Setting</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
  <div>
    <el-card>
      <template #header>
        <div>Template Setting</div>
      </template>
      <el-row>
        <el-col :span="24">设定名称</el-col>
        <el-col :span="12">
          <el-input v-model="setting_name"></el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">设定说明</el-col>
        <el-col :span="12">
          <el-input
            type="textarea"
            :rows="2"
            v-model="setting_remark"
          ></el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">关联模板</el-col>
        <el-col :span="12">
          <el-select
            v-model="setting_template"
            style="width: 100%"
            placeholder="Please Choose"
          >
            <el-option
              v-for="(item, index) in templates_option"
              :key="'option_' + index"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24"><div>设定属性</div></el-col>
        <el-col :span="24" v-for="(item, index) in attrs" :key="'attr' + index">
          <el-row :gutter="10">
            <el-col :span="4"
              ><el-input
                v-model="attrs[index].name"
                placeholder="输入属性名(string)"
              ></el-input
            ></el-col>
            <el-col :span="2"
              ><el-select
                v-model="attrs[index].type"
                placeholder="选择类型"
                style="width: 100%"
                ><el-option
                  v-for="(item, index) in type_options"
                  :value="item"
                  :label="item"
                  :key="item"
                ></el-option></el-select
            ></el-col>
            <el-col :span="8"
              ><el-input
                v-model="attrs[index].value"
                placeholder="输入值(string)"
                v-if="attrs[index].type !== 'boolean'"
              >
              </el-input>
              <el-select
                v-model="attrs[index].value"
                placeholder="选择值"
                style="width: 100%"
                v-if="attrs[index].type === 'boolean'"
                ><el-option :value="true" label="true">true</el-option
                ><el-option :value="false" label="false"
                  >false</el-option
                ></el-select
              ></el-col
            >
            <el-col :span="10"
              ><el-button @click="Remove(index)">移除</el-button>
              <el-button v-if="index === attrs.length - 1" @click="Add"
                >添加</el-button
              >
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-button type="primary" @click="save">保存</el-button>
          <el-button type="danger" @click="del">删除</el-button>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import { request } from '@/network/request';
import { ElMessage, ElMessageBox } from 'element-plus';
import { v4 } from 'uuid';

const setting_name = ref();
const setting_remark = ref();
const setting_template = ref();
const attrs = ref([{ name: '', value: '', type: 'string' }]);
const templates_option = ref([]);
const type_options = ref(['string', 'number', 'boolean']);
const setting_type = 'tandc';
const id = ref('');

onMounted(async () => {
  await request({
    url: '/admin/GetTemplateList',
    method: 'get',
  }).then((res) => {
    templates_option.value = res.data.data.map((item) => {
      return {
        label: `${item.id} - ${item.template_name}`,
        value: item.id,
      };
    });
  });

  if (window.location.href.indexOf('id') > -1) {
    id.value = window.location.href.split('id=')[1];
    getSetting();
  } else {
    id.value = v4();
  }
});

const getSetting = () => {
  request({
    url: '/admin/GetSetting',
    method: 'get',
    params: {
      id: id.value,
    },
  }).then((res) => {
    setting_name.value = res.data.setting_name;
    setting_remark.value = res.data.setting_remark;
    setting_template.value = res.data.setting_template;
    attrs.value = JSON.parse(res.data.setting_match);
  });
};

const save = () => {
  const data = {
    id: id.value,
    setting_name: setting_name.value,
    setting_remark: setting_remark.value,
    setting_template: setting_template.value,
    setting_type,
    setting_match: JSON.stringify(attrs.value),
    setting_match_columns: JSON.stringify(attrs.value.map((t) => t.name)),
    setting_match_count: attrs.value.length,
  };
  request({
    url: '/admin/SaveSetting',
    method: 'post',
    data: data,
  }).then((res) => {
    if (res.data.message) {
      ElMessage({
        type: 'warning',
        message: res.data.message,
      });
    } else {
      ElMessage({
        message: 'save success',
        type: 'success',
      });
      location.href = '/tandcTemplate?type=list';
    }
  });
};

const del = () => {
  ElMessageBox.confirm('Are you sure to delete this setting?', 'Warning', {
    confirmButtonText: 'OK',
    cancelButtonText: 'Cancel',
    customClass: 'matrix-message-box',
    confirmButtonClass: 'right-confirm-1',
  })
    .then(() => {
      request({
        url: '/admin/DelSetting',
        method: 'post',
        params: {
          id: id.value,
        },
      }).then((res) => {
        if (res.data.message) {
          ElMessage({
            type: 'warning',
            message: res.data.message,
          });
        } else {
          ElMessage({
            message: 'delete success',
            type: 'success',
          });
          location.href = '/tandcTemplate?type=list';
        }
      });
    })
    .catch(() => {});
};

const Add = () => {
  attrs.value.push({ name: '', value: '', type: 'string' });
};
</script>
<style scoped></style>
